import { render, staticRenderFns } from "./Profession.vue?vue&type=template&id=286bc716&scoped=true"
import script from "./Profession.vue?vue&type=script&lang=js"
export * from "./Profession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286bc716",
  null
  
)

export default component.exports